import React, { useEffect } from "react";
import { useState } from "react";
import ColorPicker from "react-best-gradient-color-picker";

import { faTrashAlt, faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import {
  videoConferenceText,
  videoConferenceColor,
  videoConferenceSize,
  videoConferenceType,
  videoConferenceLink,
  resetvideoConference,
} from "../../../../slice/Features/videoConference";
import { currentFeature } from "../../../../slice/features";

import axios from "axios";
import { toast } from "react-toastify";
import lang from "../../../../assets/lang/icons.json";
import BodyLoading from "../../Loading/BodyLoading";
// import Pro from "../../Pro/Pro";
import style from "./VideoConference.module.css";

const VideoConference = () => {
  // const ytApi = "AIzaSyBrIhqUWtoN7DyYCTegN39vjrdWWPAJ6qg";
  // const ytUrl = "https://www.googleapis.com/youtube/v3/search";
  // async function get() {
  //   try {
  //     const res = await axios.get(`${ytUrl}?part=snippit&key=${ytApi}`);
  //     const data = await res.json();
  //     console.log(data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  // get();
  const dispatch = useDispatch();
  const isAuth = localStorage.getItem("auth_token") ? true : false;

  const userFeatures = useSelector((state) => state.userFeatures);
  const videoConference = useSelector((state) => state.videoConference);

  const [bodyLoading, setBodyLoading] = useState(false);
  const [type, setType] = useState("");

  const [Text, setText] = useState(
    type !== "" ? lang.features.VideoConferenceText.Zoom : ""
  );
  const [Color, setColor] = useState(
    videoConference.videoConferenceColor[0].videoConferenceColor
  );
  const [Size, setSize] = useState(
    videoConference.videoConferenceSize[0].videoConferenceSize
  );

  const [showColorPicker, setShowColorPicker] = useState(false);
  const [Link, setLink] = useState("");

  const CancelFeature = (e) => {
    e.preventDefault();
    dispatch(currentFeature(""));
  };

  const handleNameColor = () => {
    setShowColorPicker(!showColorPicker);
  };

  const saveFeature = async (e) => {
    e.preventDefault();
    dispatch(currentFeature(""));
    try {
      const data = {
        text: Text,
        color: Color,
        size: Size,
        type: type,
        link: Link,
      };

      const response = await axios.post("/add/VideoConference", data);
      if (response.data.status === 200) {
        console.log(response.data);
        toast.success(response.data.message, {
          closeOnClick: true,
          theme: "colored",
        });
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resetVideoConference = async () => {
    if (isAuth) {
      try {
        const response = await axios.post("/reset/VideoConference");
        if (response.data.status === 200) {
          setText("");
          setColor("rgba(40,44,166,100)");
          setSize("1");
          setType("zoom");
          setLink("");
          fetch();
          toast.info(response.data.message, {
            closeOnClick: true,
            theme: "colored",
          });
        } else {
          console.log(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const fetch = async () => {
    try {
      const response = await axios.get("/getUser");
      const user = await response.data.user;

      if (user.video_conference_id !== null) {
        dispatch(videoConferenceText(user.video_conference.button_name));
        dispatch(videoConferenceColor(user.video_conference.color));
        dispatch(videoConferenceSize(user.video_conference.size));
        dispatch(videoConferenceType(user.video_conference.multiple_apps));
        dispatch(videoConferenceLink(user.video_conference.link));

        setText(user.video_conference.button_name);
        setColor(user.video_conference.color);
        setSize(user.video_conference.size);
        setType(user.video_conference.multiple_apps);
        setLink(user.video_conference.link);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dispatch(videoConferenceText(Text));
    dispatch(videoConferenceColor(Color));
    dispatch(videoConferenceSize(Size));
    dispatch(videoConferenceType(type));
    dispatch(videoConferenceLink(Link));
  }, [Text, Color, Size, type, Link, dispatch, isAuth]);

  useEffect(() => {
    if (isAuth) {
      fetch();
    }
  }, [isAuth]);
  return (
    <div className={`text-start `}>
      <h6>Video Conference</h6>
      {bodyLoading ? <BodyLoading /> : null}
      <div className="" style={{ minHeight: "650px" }}>
        <div className="my-3 d-flex flex-wrap">
          <div className="w-25">
            <div className="p-3 d-flex flex-column">
              <label>Zoom</label>
              <button
                onClick={() => {
                  setText(lang.features.VideoConferenceText.Zoom);
                  setType("zoom");
                }}
                className={`${style.VideoConBtn} ${
                  type === "zoom" ? `${style.active}` : ""
                }`}
              >
                <img
                  src={`${lang.features.VideoConferenceImages.Zoom}`}
                  alt="test"
                />
              </button>
            </div>
          </div>
          <div className="w-25">
            <div className="p-3 d-flex flex-column">
              <label>Google Meet</label>
              <button
                onClick={() => {
                  setText(lang.features.VideoConferenceText.GoogleMeet);
                  setType("googleMeet");
                }}
                className={`${style.VideoConBtn} ${
                  type === "googleMeet" ? `${style.active}` : ""
                }`}
              >
                <img
                  src={`${lang.features.VideoConferenceImages.GoogleMeet}`}
                  alt="test"
                />
              </button>
            </div>
          </div>
          <div className="w-25">
            <div className="p-3 d-flex flex-column">
              <label>Microsoft Team</label>
              <button
                onClick={() => {
                  setText(lang.features.VideoConferenceText.MicroSoftTeam);
                  setType("microsoftTeam");
                }}
                className={`${style.VideoConBtn} ${
                  type === "microsoftTeam" ? `${style.active}` : ""
                }`}
              >
                <img
                  src={`${lang.features.VideoConferenceImages.MicroSoftTeam}`}
                  alt="test"
                />
              </button>
            </div>
          </div>
          <div className="w-25">
            <div className="p-3 d-flex flex-column">
              <label>Skype</label>
              <button
                onClick={() => {
                  setText(lang.features.VideoConferenceText.Skype);
                  setType("skype");
                }}
                className={`${style.VideoConBtn} ${
                  type === "skype" ? `${style.active}` : ""
                }`}
              >
                <img
                  src={`${lang.features.VideoConferenceImages.Skype}`}
                  alt="test"
                />
              </button>
            </div>
          </div>
        </div>

        <div className="d-flex flex-wrap">
          <span className="w-100 custom-header"> Style</span>

          <div className="mb-4 position-relative d-flex align-items-center flex-wrap w-100">
            <div className="w-25">
              <label className="d-block custom-lable ">Button Text</label>
            </div>
            <div className="w-50">
              <input
                className={`${style.customStyInput2} form-control`}
                type="text"
                value={Text}
                onChange={(event) => {
                  setText(event.target.value);
                }}
              />
            </div>
          </div>

          <div className="mb-4 position-relative d-flex align-items-center flex-wrap w-100">
            <div className="w-25">
              <label className="d-block custom-lable ">Size</label>
            </div>
            <div className="w-50">
              <input
                className={`${style.customStyInput2} `}
                type="range"
                step={1}
                min={0}
                max={2}
                value={Size}
                onChange={(event) => {
                  setSize(Number(event.target.value));
                }}
              />
            </div>
          </div>

          <div className="mb-4 position-relative d-flex align-items-center flex-wrap w-100">
            <div className="w-25">
              <label className="d-block custom-lable ">Button Color</label>
            </div>
            <div className="w-50">
              <button
                className={`${style.customStyColorPicker}`}
                onClick={handleNameColor}
                style={{
                  background: Color,
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                }}
              />
              {showColorPicker ? (
                <ColorPicker
                  className={`${style.customColorPicker} my-2  `}
                  value={Color}
                  onChange={setColor}
                  hideOpacity={true}
                  hideControls={true}
                  hidePresets={true}
                  width={250}
                  height={250}
                />
              ) : null}
            </div>
          </div>

          {/* <div className="mb-4 position-relative d-flex align-items-center flex-wrap w-100">
            <div className="w-25">
              <label className="d-block custom-lable "> Shape</label>
            </div>
            <div className={`${style.imageShapeIcons}`}>
              <div
                className={`${style.imageShapeIcon} 
                
                `}
                data-value="square"
                // onClick={() => setImageShapeValue("square")}
              >
                <FontAwesomeIcon
                  icon={faSquare}
                  //   onClick={() => setImageShapeValue("square")}
                />
              </div>

              <div
                className={`${style.imageShapeIcon} `}
                data-value="circle"
                // onClick={() => setImageShapeValue("circle")}
              >
                <FontAwesomeIcon
                  icon={faCircle}
                  //   onClick={() => setImageShapeValue("circle")}
                />
              </div>
            </div>
          </div> */}
        </div>
        <div className="mb-4 position-relative d-flex align-items-center flex-wrap w-100">
          <FontAwesomeIcon icon={faLink} />
          <input
            className={`${style.customStyInput2} form-control ms-4 w-75`}
            placeholder="Link"
            type="text"
            value={Link}
            onChange={(e) => setLink(e.target.value)}
          />
        </div>

        {Text && isAuth ? (
          <div
            className=" py-2 px-3 d-flex flex-wrap"
            style={{ background: "silver" }}
          >
            <button
              className={`${style.btnReset}`}
              onClick={resetVideoConference}
            >
              <FontAwesomeIcon icon={faTrashAlt} className="me-1" />
              Reset
            </button>
          </div>
        ) : null}
      </div>
      <div className="my-3">
        <button
          className={`btn btn-primary me-2 ${Text ? "" : "disabled"}`}
          onClick={saveFeature}
        >
          save
        </button>
        <button className="btn btn-outline-secondary" onClick={CancelFeature}>
          Cancel
        </button>
      </div>
    </div>
  );
};
export default VideoConference;
